import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { relationshipOptions } from "../../Dashboard/constants/relationship";
import { BeneficiaryId, LocalDate, } from "../../Types";
import ValidationError from "../../ZodError";
import { Address, Name, TaxInformation } from "./getClientProfile";
import { BeneficiaryContactInformation } from "./postClientBeneficiary";
const BeneficiaryAddress = Address.extend({
    country: z.literal("US"),
});
const BeneficiaryTaxInformation = TaxInformation.extend({
    taxIdType: z.enum(["SSN", "ITIN"]),
});
const Beneficiary = z.object({
    beneficiaryId: BeneficiaryId,
    name: Name,
    dateOfBirth: LocalDate,
    contactInformation: BeneficiaryContactInformation.nullable(),
    relationshipIndicator: z.enum(relationshipOptions),
    address: BeneficiaryAddress.nullable(),
    taxInformation: BeneficiaryTaxInformation.nullable(),
});
const Response = Beneficiary.array();
export const url = (clientId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/v1/clientside/${clientId}/beneficiaries`
        : `https://middleware.uat.farther.com/entity/v1/clientside/${clientId}/beneficiaries`;
};
export default async function getClientBeneficiaries(clientId, config) {
    const { data } = await axios.get(url(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: clientId, //Client Must be present in the header
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[${getClientBeneficiaries.name}] Could not parse`;
        console.error(`${errorMessage}, ${decoded.error.message}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientBeneficiaries.js.map